import React from 'react';
import PropTypes from 'prop-types';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';

const styles = {
  underlineStyle: {
    borderTop: 0,
  },
}

const SharedDropDownMenu = ({ value, iconStyle = {}, datasets, onChange, labelPrefix, labelStyle = {}, ...rest }) => {
  iconStyle = Object.assign({ top: 0, right: 0 }, iconStyle);
  labelStyle = Object.assign({ paddingRight: 40 }, labelStyle);
  return (
    <DropDownMenu
      value={value}
      underlineStyle={styles.underlineStyle}
      iconStyle={iconStyle}
      onChange={onChange}
      labelStyle={labelStyle}
      {...rest}
    >
      {Object.keys(datasets).map((datasetKey, index) => (
        <MenuItem
          primaryText={datasets[datasetKey].name || datasetKey}
          label={(labelPrefix || '') + (datasets[datasetKey].name || datasetKey)}
          value={datasetKey}
          key={index}
        />
      ))}
    </DropDownMenu>
  )
}

SharedDropDownMenu.propTypes = {
  value: PropTypes.string,
  iconStyle: PropTypes.object,
  datasets: PropTypes.object,
  labelStyle: PropTypes.object,
  onChange: PropTypes.func,
  labelPrefix: PropTypes.string,
}

export default SharedDropDownMenu;



// WEBPACK FOOTER //
// ./src/components/SharedDropDownMenu/index.jsx